import React from 'react';
import { useIntl } from 'react-intl';
import FormattedHTMLMessage from '@/components/FormattedHTMLMessage';
import Error from '@/components/errors/Error';

const SearchWarning = ({ warning }) => {
  const intl = useIntl();
  const getWarningHeader = () => {
    let id = `search.warnings.${warning.type}.title`;
    if (!intl.messages[id]) {
      id = 'search.warnings.title';
    }
    return intl.formatMessage({ id });
  };

  const getWarningMessage = () => {
    const id = `search.warnings.${warning.type}.content`;
    if (!intl.messages[id]) {
      return warning.message;
    }
    return (<FormattedHTMLMessage id={id} />);
  };

  return (<Error warning title={getWarningHeader()} error={getWarningMessage()} />);
};

export default SearchWarning;
